import { createSelector } from 'reselect';

import type { SuggestCoupon } from '../../types/Subtotal';
import { State } from '../reducers/freeDeliveryReducer';
import { RootState } from '../rootReducer';
import { makeBillDetailDataByName } from '../selectors/billDetail';
import { makeMemberRole } from '../selectors/member';

const freeDeliveryReducerRaw = (state: RootState) =>
  state?.freeDeliveryReducer || {};

export const makeDataByKey = (key: keyof State, defaultValue?: any) => {
  return createSelector(freeDeliveryReducerRaw, (state: State) => {
    return state[key] ?? defaultValue;
  });
};

export const makeFreeDeliveryThreshold = () => {
  return createSelector(
    makeMemberRole(),
    makeDataByKey('threshold'),
    makeBillDetailDataByName('free_shipping_diff'),
    (role, threshold, freeShippingDiff) =>
      role === 'ghost' ? threshold : freeShippingDiff
  );
};

export const makeSuggestCoupon = () => {
  return createSelector(
    makeBillDetailDataByName('suggest_coupon'),
    suggestCoupon => (suggestCoupon || { value: 0, diff: 0 }) as SuggestCoupon
  );
};

export const makeIsReachThreshold = () => {
  return createSelector(makeFreeDeliveryThreshold(), freeShippingDiff => {
    return freeShippingDiff <= 0 || false;
  });
};
